import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { CODIGO_CENTRUS } from '../../../../app.constants';
import { OcorrenciaReservaPoupancaModel } from '../../../shared/models/ocorrencia-reserva-poupanca.model';
import { PessoaDadosSimplicadosModel } from '../../../shared/models/pessoa-simplificada.model';
import { ReservaPoupancaModel } from '../../../shared/models/reserva-poupanca.model';
import { PBDCReservaPoupancaPdf } from '../../../shared/services/documentos-pdf-imprimir/Plano/pbdc/pbdc-reserva-poupanca-pdf copy';
import { PessoaService } from '../../../shared/services/pessoa.service';
import { StorafeUtil } from '../../../shared/util/storasge.util';
import { PbdcService } from '../service/pbdc.service';
import { AuthInterceptor } from '../../../interceptor/auth.interceptor';
import { MessageUtil } from '../../../shared/messages/messageUtil';

@Component({
  selector: 'app-pbdc-reserva-poupanca',
  templateUrl: './pbdc-reserva-poupanca.component.html',
  styleUrls: ['./pbdc-reserva-poupanca.component.css']
})
export class PbdcReservaPoupancaComponent implements OnInit {

  componentes: any[] = [1];

  nrSuperavit = 1;

  @BlockUI() blockUi: NgBlockUI;
  page = 0;
  rows = 14;
  totalRecords = 0;

  linkAtivo = false;
  linkPatronal = false;
  linkPatronalCentrus = false;
  linkAssistido = false;
  linkPatronalAssistido = false;
  tipo = 0;

  verificarPatronalRetorno = false;

  ocorrenciaReservaPoupancaModel: Array<OcorrenciaReservaPoupancaModel> = Array<OcorrenciaReservaPoupancaModel>();

  reservaPoupancaModel: ReservaPoupancaModel = new ReservaPoupancaModel();

  pessoaDadosSimplicadosModel: PessoaDadosSimplicadosModel = new PessoaDadosSimplicadosModel();

  cdCentrus: number;
  cdCentrusTit: number;


  param: string;
  titulo: string;
  mensagem: string;
  mensagemFooter: string;

  constructor(
    private pBDCReservaPoupancaPdf: PBDCReservaPoupancaPdf,
    private pbdcService: PbdcService,
    private router: Router,
    private toastrService: ToastrService,
    private authInterceptor: AuthInterceptor,
    private pessoaService: PessoaService
  ) { }

  ngOnInit() {

    this._gerenciarCodigoIndentificao();

  }


  getDadosSesseionStorage(): Promise<string> {

    return new Promise((resolve, reject) => {
      const recuperandoObjeto = StorafeUtil.recuperarSessionStorage(CODIGO_CENTRUS);
      resolve(recuperandoObjeto);
    })


  }

  private async _gerenciarCodigoIndentificao(): Promise<void> {
    await this.getDadosSesseionStorage()
      .then(recuperandoObjeto => {

        if (recuperandoObjeto) {
          const novoObjeto = Number(JSON.parse(recuperandoObjeto));
          this.cdCentrus = novoObjeto
          this.param = '/administrativo/operacoesConsultaParticipante';
        } else {
          this.cdCentrus = this.authInterceptor.getJwtCdCentrus();
          this.param = '/cardMenus/cardMenuPlanos';
        }
        this.getPessoasDadosSimplificado();
      })
  }


  async getPessoasDadosSimplificado() {
    try {
      this.pessoaDadosSimplicadosModel = await this.pessoaService.getPessoas(this.cdCentrus);
      this.getCdCentrusTitular();
      this.getVerificarDtBeneficio()
      this.getConsultaReservaPoupanca()
      this.getConsultaOcorrenciasReservaPoupanca()
    } catch (error) {
      this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 });
    }
  }


  async getCdCentrusTitular() {
    try {
      this.cdCentrusTit = await this.pessoaService.getCdCentrusTitular(this.cdCentrus);
     if (!this.cdCentrusTit) {this.cdCentrusTit = this.cdCentrus};
    } catch (error) {
      this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 });
    }
  }

  getVerificarDtBeneficio() {
    this.pbdcService.getVerificarDtBeneficio(this.cdCentrus)
  }

  async getConsultaReservaPoupanca() {

    try {
      this.reservaPoupancaModel = await this.pbdcService.getConsultaReservaPoupanca(this.cdCentrus)

      this.reservaPoupancaModel.vlTxAdministracao = Number(this.reservaPoupancaModel.vlTotAtualizacao) + Number(this.reservaPoupancaModel.vlTotContribuicao)

    } catch (error) {
      this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 });
    }
  }

  paginacao(evento) {
    this.page = evento['page'];
    this.rows = evento['rows'];
    this.getConsultaOcorrenciasReservaPoupanca();
  }

  async getConsultaOcorrenciasReservaPoupanca() {

    const listaRetorno = await this.pbdcService.getPageConsultaOcorrenciasReservaPoupanca(this.cdCentrus, this.rows, this.page);

    if (listaRetorno['totalElements'] <= 0) { this.voltarForcada(); return; };

    try {

      this.ocorrenciaReservaPoupancaModel = listaRetorno['content'];
      this.totalRecords = listaRetorno['totalElements'];
    } catch (error) {
      this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 });
    }
  }
  voltarForcada(): void {
    this.router.navigate([this.param], { skipLocationChange: true });
    this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 })
  }

  formatarDataBaseAtualizacao(dataReferencia: string){
    return dataReferencia.substring(3);
  }


  async imprimirPagina() {
    try {
      const ocorrenciaReservaPoupancaModel = await this.pbdcService.getConsultaOcorrenciasReservaPoupanca(this.cdCentrus);
      this.pBDCReservaPoupancaPdf.funcionarios(
        this.pessoaDadosSimplicadosModel,
        ocorrenciaReservaPoupancaModel,
        this.reservaPoupancaModel);
    } catch (error) {
      console.error(error);
    }
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/planos/plano/pbdc-reserva-poupanca/pbdc-reserva-poupanca.component.ts